// @core/api/endpoints/userprofile/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ActivateAvatar } from './activate_avatar';
import { ActivateBanner } from './activate_banner';
import { ActivateUserprofile } from './activate_userprofile';
import { BanUserprofile } from './ban_userprofile';
import { CreateAvatar } from './create_avatar';
import { CreateAvatarsBulk } from './create_avatars_bulk';
import { CreateBanner } from './create_banner';
import { CreateDefaultProfileOnUserCreated } from './create_default_profile_on_user_created';
import { CreateUserprofile } from './create_userprofile';
import { DeleteAvatar } from './delete_avatar';
import { DeleteAvatarsBulk } from './delete_avatars_bulk';
import { DeleteBanner } from './delete_banner';
import { DeleteUISettings } from './delete_ui_settings';
import { DeleteUserprofile } from './delete_userprofile';
import { DeleteUserprofileByUserID } from './delete_userprofile_by_user_id';
import { GetAvatar } from './get_avatar';
import { GetBanner } from './get_banner';
import { GetPrivacySettings } from './get_privacy_settings';
import { GetUISettings } from './get_ui_settings';
import { GetUserprofile } from './get_userprofile';
import { GetUserprofileActive } from './get_userprofile_active';
import { GetUserprofileAdmin } from './get_userprofile_admin';
import { GetUserprofileDefault } from './get_userprofile_default';
import { GetUserprofileDefaultID } from './get_userprofile_default_id';
import { ListAvatars } from './list_avatars';
import { ListAvatarsByOwner } from './list_avatars_by_owner';
import { ListBanners } from './list_banners';
import { ListUserprofileBanHistory } from './list_userprofile_ban_history';
import { ListUserprofiles } from './list_userprofiles';
import { ListUserprofilesAdmin } from './list_userprofiles_admin';
import { ListUserprofilesByIDs } from './list_userprofiles_by_ids';
import { ListUserprofilesForService } from './list_userprofiles_for_service';
import { SearchUserprofiles } from './search_userprofiles';
import { SetPrivacySettings } from './set_privacy_settings';
import { SetUISettings } from './set_ui_settings';
import { SetUserprofileDefault } from './set_userprofile_default';
import { UnbanUserprofile } from './unban_userprofile';
import { UpdateAvatar } from './update_avatar';
import { UpdateBanner } from './update_banner';
import { UpdateUserprofile } from './update_userprofile';

// Re-export individual endpoints
export {
  ActivateAvatar,
  ActivateBanner,
  ActivateUserprofile,
  BanUserprofile,
  CreateAvatar,
  CreateAvatarsBulk,
  CreateBanner,
  CreateDefaultProfileOnUserCreated,
  CreateUserprofile,
  DeleteAvatar,
  DeleteAvatarsBulk,
  DeleteBanner,
  DeleteUISettings,
  DeleteUserprofile,
  DeleteUserprofileByUserID,
  GetAvatar,
  GetBanner,
  GetPrivacySettings,
  GetUISettings,
  GetUserprofile,
  GetUserprofileActive,
  GetUserprofileAdmin,
  GetUserprofileDefault,
  GetUserprofileDefaultID,
  ListAvatars,
  ListAvatarsByOwner,
  ListBanners,
  ListUserprofileBanHistory,
  ListUserprofiles,
  ListUserprofilesAdmin,
  ListUserprofilesByIDs,
  ListUserprofilesForService,
  SearchUserprofiles,
  SetPrivacySettings,
  SetUISettings,
  SetUserprofileDefault,
  UnbanUserprofile,
  UpdateAvatar,
  UpdateBanner,
  UpdateUserprofile,
};

// Namespace export for convenient usage
export const userprofileApi = {
  ActivateAvatar,
  ActivateBanner,
  ActivateUserprofile,
  BanUserprofile,
  CreateAvatar,
  CreateAvatarsBulk,
  CreateBanner,
  CreateDefaultProfileOnUserCreated,
  CreateUserprofile,
  DeleteAvatar,
  DeleteAvatarsBulk,
  DeleteBanner,
  DeleteUISettings,
  DeleteUserprofile,
  DeleteUserprofileByUserID,
  GetAvatar,
  GetBanner,
  GetPrivacySettings,
  GetUISettings,
  GetUserprofile,
  GetUserprofileActive,
  GetUserprofileAdmin,
  GetUserprofileDefault,
  GetUserprofileDefaultID,
  ListAvatars,
  ListAvatarsByOwner,
  ListBanners,
  ListUserprofileBanHistory,
  ListUserprofiles,
  ListUserprofilesAdmin,
  ListUserprofilesByIDs,
  ListUserprofilesForService,
  SearchUserprofiles,
  SetPrivacySettings,
  SetUISettings,
  SetUserprofileDefault,
  UnbanUserprofile,
  UpdateAvatar,
  UpdateBanner,
  UpdateUserprofile,
};
